import { PostMessageOptions } from "."

export function handleGetCheckHasMemo({ data, props, source }: PostMessageOptions) {
    if (!data.getCheckHasMemo || !source) {
        return
    }

    props.getCheckHasMemo?.().then((checkHasMemo) => {
        source.postMessage({ checkHasMemo }, "*")
    })
}
